import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

import { type LegacySiteHistoryLabels } from '../../generics/LegacySitePrimitives.js'
import { legacySiteId, type LegacySiteId } from './LegacySite.js'
import {
  legacySiteLoggerHistoryId,
  type LegacySiteLoggerHistoryId,
} from './LegacySiteLoggerHistory.js'
import { loggerId, type LoggerId } from './Logger.js'
import { manufacturerId, type ManufacturerId } from './Manufacturer.js'

/** Represents the view public.legacy_site_logger_history_view_ */
export default interface LegacySiteLoggerHistoryViewTable {
  /** Database type: pg_catalog.uuid */
  id: ColumnType<LegacySiteLoggerHistoryId, never, never>

  /** Database type: pg_catalog.int4 */
  siteId: ColumnType<LegacySiteId, never, never>

  /** Database type: pg_catalog.int4 */
  loggerId: ColumnType<LoggerId | null, never, never>

  /** Database type: pg_catalog.text */
  loggerSerial: ColumnType<string, never, never>

  /** Database type: pg_catalog.text */
  manufacturer: ColumnType<ManufacturerId, never, never>

  /** Database type: pg_catalog.text */
  manufacturerDeviceId: ColumnType<string | null, never, never>

  /** Database type: pg_catalog.text */
  imei: ColumnType<string | null, never, never>

  /** Database type: pg_catalog.timestamptz */
  startedAt: ColumnType<Date, never, never>

  /** Database type: pg_catalog.timestamptz */
  endedAt: ColumnType<Date | null, never, never>

  /** Database type: pg_catalog.int4[] */
  decode: ColumnType<number[] | null, never, never>

  /** Database type: pg_catalog.text */
  dataType: ColumnType<string | null, never, never>

  /** Database type: pg_catalog.jsonb */
  labels: ColumnType<LegacySiteHistoryLabels | null, never, never>
}

export type LegacySiteLoggerHistoryView =
  Selectable<LegacySiteLoggerHistoryViewTable>

export const legacySiteLoggerHistoryView = z.object({
  id: legacySiteLoggerHistoryId,
  siteId: legacySiteId,
  loggerId: loggerId.nullable().optional(),
  loggerSerial: z.string(),
  manufacturer: manufacturerId,
  manufacturerDeviceId: z.string().nullable().optional(),
  imei: z.string().nullable().optional(),
  startedAt: z.coerce.date(),
  endedAt: z.coerce.date().nullable().optional(),
  decode: z.number().nullable().optional(),
  dataType: z.string().nullable().optional(),
  labels: z.unknown().nullable().optional(),
}) as unknown as z.Schema<LegacySiteLoggerHistoryView>
